import React from 'react';
import { object } from 'prop-types';
import { formatCurrency, formatDate } from '@ajaibid/utils';

import { styDetail } from './style';

/**
 * @param {object}  DetailProps
 * @param {import('@services/api/stock/history/regular').HistoryRegular}  DetailProps.item
 */
function Detail({ item }) {
  const {
    idx_order_no: idxOrderNo,
    trade_date: tradeDate,
    lot,
    fee,
    counter,
    tradetime: tradeTime,
  } = item;

  return (
    <section className={styDetail}>
      <div>
        <div>
          <span>IDX order </span>
          <span>{idxOrderNo}</span>
        </div>
        <div>
          <span>Counter</span>
          <span>{counter || '-'}</span>
        </div>
      </div>
      <div>
        <div>
          <span>Detail Time</span>
          <span>{formatDate(tradeDate, 'DD MMM YYYY HH:mm')}</span>
        </div>
        <div>
          <span>Trade Time</span>
          <span>{tradeTime || '-'}</span>
        </div>
      </div>
      <div>
        <div>
          <span>Lot Done</span>
          <span>{lot}</span>
        </div>
        <div>
          <span>Fee</span>
          <span>{fee ? formatCurrency(fee, 'IDR') : '-'}</span>
        </div>
      </div>
    </section>
  );
}

Detail.propTypes = {
  item: object.isRequired,
};

export default Detail;
